var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-6",attrs:{"fluid":""}},[_c('v-row',[(!_vm.noColumn)?_c('v-col',{attrs:{"cols":"12"}},[_vm._t("default")],2):_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }